import styled, { css } from "styled-components"

import { formatPriceByLocale } from "utils/utils"

import Button from "components/presenters/common/form/Button"

export default function PaymentButton({
  existCurrShipping,
  totalPrice,
  isValid,
  onAlertAgreement,
  onPayment,
}) {
  return !existCurrShipping ? (
    <ButtonStyle fullWidth>배송지를 입력해주세요</ButtonStyle>
  ) : !isValid ? (
    <ButtonStyle onClick={onAlertAgreement} fullWidth>{`${formatPriceByLocale(
      "ko",
      totalPrice
    )}원 결제하기`}</ButtonStyle>
  ) : (
    <ActiveButtonStyle onClick={onPayment} fullWidth>
      {`${formatPriceByLocale("ko", totalPrice)}원 결제하기`}
    </ActiveButtonStyle>
  )
}

const buttonStyle = css`
  padding: calc(100vw * (23 / 375)) 0;
  font-size: calc(100vw * (18 / 375));
  font-weight: 700;
  line-height: calc(100vw * (26 / 375));
`

const ButtonStyle = styled(Button)`
  ${buttonStyle}
  background-color: #D8D8D8;
  color: #989898;
`

const ActiveButtonStyle = styled(Button)`
  ${buttonStyle}
`
